import { render, staticRenderFns } from "./CompanyDashboard.vue?vue&type=template&id=3cbb01b2&scoped=true&"
import script from "../../services/company/company-dashboard.js?vue&type=script&lang=js&"
export * from "../../services/company/company-dashboard.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/profile.css?vue&type=style&index=0&id=3cbb01b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbb01b2",
  null
  
)

export default component.exports